import React from "react";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";
import PermissionChangeBtn from "../PermissionChangeBtn.component";
import "../../../../../styles/ComponentsStyles/Setting/Permission/PermissionApprovedCard.style.css";
const PermissionApprovedCard = () => {
  return (
    <div
      className="w-full flex-row align-center justify-between p-1 permissionGrantedListLi"
      style={{ borderBottom: "2px solid var(--grayBorder)" }}
    >
      <ProfileViewer
        imageSource={"https://randomuser.me/api/portraits/women/45.jpg"}
        imageWidth={"3rem"}
        imageHeight={"3rem"}
        name={"Md Rejuwanul Karim"}
        _id={"SMSSJSK"}
      />
      <span className="t-13 poppins color-greenColor">Member</span>
      <span className="t-13 poppins color-greenColor">Act admin</span>
      <PermissionChangeBtn />
      <button type="button" className="deleteBtnFill pl-2 pr-2">
        Remove
      </button>
    </div>
  );
};

export default PermissionApprovedCard;
